import { useEffect, useState } from "react";
// import toast from 'react-hot-toast';
import { useLocation, useNavigate } from "react-router-dom";

const DesignStudioShow = () => {
  const location = useLocation();
  const Navigate = useNavigate();
  const [orderId, setOrderId] = useState("");
  const [images, setImages] = useState([]);
  const [status, setStatus] = useState("");

  useEffect(() => {
    if (location?.state === null) {
      setOrderId(location?.state?.id);
      setImages(location?.state?.images);
      setStatus(location?.state?.status);
      Navigate("/admin/dashboard");
    } else {
      setOrderId(location?.state?.id);
      setImages(location?.state?.images);
      setStatus(location?.state?.status);
    }
  }, []);

  return (
    <div className="al">
      <div className="al-head">
        <div>
          <h1 className="al-title">Design Studio Details</h1>
          <p className="al-sub">View this design order.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

      <div className="al-idbanner">
        <div className="al-idbanner__icon">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="13.5" cy="6.5" r=".5" /><circle cx="17.5" cy="10.5" r=".5" /><circle cx="8.5" cy="7.5" r=".5" /><circle cx="6.5" cy="12.5" r=".5" /><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z" /></svg>
        </div>
        <div>
          <div className="al-idbanner__name" style={{ fontFamily: "var(--font-mono)" }}>#{orderId || "—"}</div>
          <div className="al-idbanner__sub">Design Studio Order</div>
        </div>
        <span className="al-pill" style={{ marginLeft: "auto", background: status === false ? "var(--color-warning-bg)" : "var(--color-success-bg)", color: status === false ? "var(--color-warning-text)" : "var(--color-success-text)" }}>
          {status === false ? "Process" : "Approved"}
        </span>
      </div>

      <div className="al-card">
        <div className="al-cardhead">
          <div className="al-cardhead__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><circle cx="8.5" cy="8.5" r="1.5" /><polyline points="21 15 16 10 5 21" /></svg></div>
          <h3 className="al-cardhead__title">Order Information</h3>
        </div>
        <div className="al-spec">
          <div><div className="al-spec__lbl">Order ID</div><div className="al-spec__val" style={{ fontFamily: "var(--font-mono)" }}>{orderId || "—"}</div></div>
          <div>
            <div className="al-spec__lbl">Status</div>
            <div className="al-spec__val">
              <span className="al-pill" style={{ background: status === false ? "var(--color-warning-bg)" : "var(--color-success-bg)", color: status === false ? "var(--color-warning-text)" : "var(--color-success-text)" }}>
                {status === false ? "Process" : "Approved"}
              </span>
            </div>
          </div>
          <div className="al-spec__full">
            <div className="al-spec__lbl">Images</div>
            {Array.isArray(images) && images.length > 0 ? (
              <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginTop: "6px" }}>
                {images.map((img, i) => (
                  <img key={i} src={`${process.env.REACT_APP_IMAGE_URL}/uploads/${img}`} alt={`Studio Image ${i + 1}`}
                    style={{ width: "100px", height: "100px", borderRadius: "8px", objectFit: "cover", border: "1px solid var(--color-border)" }} />
                ))}
              </div>
            ) : (
              <div className="al-spec__val">No Images</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesignStudioShow;
